import { render, staticRenderFns } from "./FjBaseOtp.vue?vue&type=template&id=2546680e&"
import script from "./FjBaseOtp.vue?vue&type=script&lang=js&"
export * from "./FjBaseOtp.vue?vue&type=script&lang=js&"
import style0 from "./FjBaseOtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VOtpInput})
